/**
 * Snapshot helper that captures every question's pristine answer from a
 * CMM workflow document, keyed by `question.name`. Used as the ground
 * truth when detecting answer changes or reverts.
 *
 * @module pharmaQuestionaire/utils/originalAnswers
 */
import {
  Answer,
  PharmaBranchedQuestionnaire,
} from "../../../data-model/cmmMedicalNeccessityQuestionnaire";

/**
 * Builds a lookup of `question.name → question.answer` from the first
 * clinical question section of a workflow document. Questions whose
 * `name` is `null` are skipped (they have no stable identifier to key by).
 *
 * Intended to be called once against the pristine doc so callers can
 * reference the original answers across the lifetime of the page.
 *
 * @param doc - The (pristine) workflow document
 * @returns Map of `question.name` to its original `Answer`
 */
export function buildOriginalAnswerMap(
  doc: PharmaBranchedQuestionnaire,
): Map<string, Answer> {
  const map = new Map<string, Answer>();
  const questions = doc?.clinical_question_sections?.[0]?.questions ?? [];
  for (const q of questions) {
    if (q.name != null) {
      map.set(q.name, q.answer);
    }
  }
  return map;
}
